module.exports = __webpack_public_path__ + "static/Rise-5bc11af90734a83cefec3667156196fb.jpg";